// src/layout/MainLayout.jsx — premium v8.3
import Sidebar from "../components/Sidebar";
import Header  from "../components/Header";

export default function MainLayout({ children }) {
  return (
    <div style={{
      display: "flex",
      height: "100vh",
      width: "100%",
      background: "var(--bg-primary)",
      color: "var(--text-primary)",
      overflow: "hidden",
    }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <Header />
        <main style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "28px 32px",
        }}
          className="fade-in"
        >
          {children}
        </main>
      </div>
    </div>
  );
}
